import { create } from "zustand";
import lang_en from "../_locales/en.json";

const languageStore = (set) => ({
  language: lang_en,
  changeLanguage: async (newLanguage) => {
    let langModule;
    try {
      switch (newLanguage) {
        case "FRA":
          langModule = await import("../_locales/fr.json");
          break;
        case "ENG":
          langModule = await import("../_locales/en.json");
          break;
        case "SPA":
          langModule = await import("../_locales/es.json");
          break;
        case "ITA":
          langModule = await import("../_locales/it.json");
          break;
        case "DEU":
          langModule = await import("../_locales/de.json");
          break;
        default:
          langModule = await import("../_locales/en.json");
          break;
      }
      set({ language: langModule.default });
    } catch (error) {
      console.error("Failed to load language file", error);
    }
  },
});

export const useLanguage = create(languageStore);
